import React, { useState, useEffect } from "react";
import "../FatcaCRSDeclaration/FatcaCRSDeclaration.modules.css";
import "./RiskProfileDeclaration.modules.css";
import * as Helpers from "../../../../global/Helpers";
import * as utils from "../../../../global/utils";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { Redirect } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SessionExpiredPOPup from "../../SessionExpiredPOPup/SessionExpiredPOPup";

const RiskProfileDeclaration = (props) => {
  const { t } = useTranslation();
  const [address, setSelectedaddress] = useState("");

  // const handleChange = (event) => {
  //     setSelectedOption(event.target.value);
  // };
  const [redirect, setRedirect] = useState(null);

  const [isADXNIN, setisADXNIN] = useState(true);
  const [isDFMNIN, setisDFMNIN] = useState(true);
  const [ADXNIN, setADXNIN] = useState("");
  const [DFMNIN, setDFMNIN] = useState("");

  const handleSwitchADX = (event) => {
    setisADXNIN(event.target.checked);
  };
  const handleSwitchDFM = (event) => {
    setisDFMNIN(event.target.checked);
  };

  const handleADXNINChange = (event) => {
    setADXNIN(event.target.value);
  };
  const handleDFMNINChange = (event) => {
    setDFMNIN(event.target.value);
  };

  useEffect(() => {
    CallCreateDFMNin();
    CallCreateADXNin();
  }, []);

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (isADXNIN && ADXNIN === "") {
      Helpers.errorNotify(t("Please fill ADX NIN"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    if (isDFMNIN && DFMNIN === "") {
      Helpers.errorNotify(t("Please fill DFM NIN"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    return true;
  }
  const CallCreateADXNin = async () => {
    try {
      const params = {
        ReqID: localStorage.getItem("RID"),
      };
      var response = utils.CallCreateADXNin(params);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            console.log(
              "CallCreateADXNin response.data.ErrorMsg",
              response.data.ErrorMsg
            );

            // Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("CallCreateADXNin", error);
        });
    } catch (error) {
      console.log("CallCreateADXNin", error);
    }
  };
  const CallCreateDFMNin = async () => {
    try {
      const params = {
        reqID: localStorage.getItem("RID"),
      };
      var response = utils.CallCreateDFMNin(params);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            console.log(
              "CallCreateDFMNin response.data.ErrorMsg",
              response.data.ErrorMsg
            );

            // Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("CallCreateDFMNin", error);
        });
    } catch (error) {
      console.log("CallCreateDFMNin", error);
    }
  };

  const saveKycDataFun = () => {
    ;
    if (!validateSubmit()) return;
    var Items = [
      // { ID: "3", Value: ADXNIN },
      // { ID: "30", Value: DFMNIN}
    ];
    var one = isADXNIN ? { ID: "369", Value: ADXNIN } : null;
    var Two = isDFMNIN ? { ID: "371", Value: DFMNIN } : null;

    var result = Helpers.getScreenIdByGroupAndName("ADX & DFM NIN Details");

    if (one !== null) Items.push(one);
    if (Two !== null) Items.push(Two);

    if (!isADXNIN && !isDFMNIN) {
      props.setIsCallAPI(false);
      props.handleNext();
    } else {
      Items.push({ ID: "258", Value: "1" });
      props.saveKycDataAPI(Items);
    }
    Items.push({ ID: "288", Value: result?.GROUP_ID || "" });
    Items.push({ ID: "287", Value: result?.SCREEN_ID || "" });
  };

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className="FatcaCRSDeclaration  RiskProfileDeclaration">
      <div className="form-container">
        <form className="dropdown-form">
          <h5 style={{ fontWeight: "600" }}>{t("adx_dfm_nin_details")} </h5>
          <div className="form-group" style={{ marginBottom: "25px" }}>
            <div
              className=""
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "-6px",
              }}
            >
              <label htmlFor="dropdown5" className="form-label">
                {t("do_you_have_adx_nin")}
              </label>
              <div className="switch-container">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isADXNIN}
                    onChange={handleSwitchADX}
                  />
                  <span className="slider"></span>
                </label>
                {/* <p>Status: {hasPreviousOccupation ? 'ON' : 'OFF'}</p> */}
              </div>
            </div>

            <label htmlFor="dropdown3" className="form-label">
              {t("adx_nin")}
            </label>
            <input
              id="textADXNIN"
              name="ADXNIN"
              type="text"
              value={ADXNIN}
              disabled={!isADXNIN ? true : false}
              onChange={handleADXNINChange}
              className="form-select"
            />
          </div>
          <hr style={{ width: "100%" }} />
          <div className="form-group" style={{ marginBottom: "20px" }}>
            <div
              className=""
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "-6px",
              }}
            >
              <label htmlFor="dropdown5" className="form-label">
                {t("do_you_have_dfm_nin")}
              </label>
              <div className="switch-container">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isDFMNIN}
                    onChange={handleSwitchDFM}
                  />
                  <span className="slider"></span>
                </label>
                {/* <p>Status: {hasPreviousOccupation ? 'ON' : 'OFF'}</p> */}
              </div>
            </div>
            <label htmlFor="dropdown3" className="form-label">
              {t("dfm_nin")}
            </label>
            <input
              id="textADXNIN"
              name="ADXNIN"
              type="text"
              value={DFMNIN}
              disabled={!isDFMNIN ? true : false}
              onChange={handleDFMNINChange}
              className="form-select"
            />
          </div>

          {/* <button type="submit" className="submit-button">Submit</button> */}
        </form>
      </div>
    </div>
  );
};

export default RiskProfileDeclaration;
